// extracted by mini-css-extract-plugin
export default {"root-header":"Table_root-header__CSCpB","root-row":"Table_root-row__LYenv","nowcasting-info":"Table_nowcasting-info__7xHX5","title":"Table_title__ZvObs"};